import Button from '@/common/components/Button'
import { PaymentModalityType } from '@/features/companies/types/companies.type'
import { ApproveGovernmentAllocationEntryModal } from '@/features/privateCompanies/components/GovernmentAllocationEntryReviewButtons/ApproveGovernmentAllocationEntryModal'
import { DeclineGovernmentAllocationEntryModal } from '@/features/privateCompanies/components/GovernmentAllocationEntryReviewButtons/DeclineGovernmentAllocationEntryModal'

interface GovernmentAllocationEntryReviewButtonsProps {
  governmentAllocationKind?: PaymentModalityType
  reviewState?: string
}

export const GovernmentAllocationEntryReviewButtons = ({
  governmentAllocationKind,
  reviewState,
}: GovernmentAllocationEntryReviewButtonsProps) => {
  return (
    <div className="flex gap-2">
      {reviewState === 'disapproved' ? (
        <Button type="button" className="w-[164px] cursor-default" variant="error" disabled>
          Declinado
        </Button>
      ) : (
        <DeclineGovernmentAllocationEntryModal governmentAllocationKind={governmentAllocationKind} />
      )}
      {reviewState === 'approved' ? (
        <Button type="button" className="w-[164px] bg-success-disabled" disabled>
          Aprovado
        </Button>
      ) : (
        <ApproveGovernmentAllocationEntryModal governmentAllocationKind={governmentAllocationKind} />
      )}
    </div>
  )
}
